import { createSortOption } from "@nosto/preact"
export const sizes = [24]

export const sortOptions = [
    createSortOption("score", "Most relevant", { field: "score", order: "desc" }),
    // createSortOption("name", "Alphabetically, A-Z", { field: "customFields.custom_fields-style", order: "asc" }),
    // createSortOption("-name", "Alphabetically, Z-A", { field: "customFields.custom_fields-style", order: "desc" }),
    createSortOption("price", "Price, low to high", { field: "price", order: "asc" }),
    createSortOption("-price", "Price high to low", { field: "price", order: "desc" })
    // createSortOption("date", "Date, old to new", { field: "datePublished", order: "asc" }),
    // createSortOption("-date", "Date, new to old", { field: "datePublished", order: "desc" })
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: 5,
    historySize: 4
}
